import { makeImageUrls, ImageProps } from "@ezbuy/smartimagesrc";

const defaultImage = "https://i.ezbuy.sg/Fovpler_pmD9tracgR0azz00yXMY";

export function* imageSourceGenerator(
	originSrc: string,
	params: ImageProps,
	fallbackSrc: string | false = defaultImage,
) {
	const urls = makeImageUrls(originSrc, params);

	if (fallbackSrc) {
		urls.push(fallbackSrc);
	}
	for (let i = 0, l = urls.length; i < l; i++) {
		yield urls[i];
	}
	return originSrc;
}
